import clsx from 'clsx';
import { FieldErrors, FieldValues } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';
import { InfoFilled } from 'ui/icons';
import { Input } from 'ui/mobile-ds';
import FormError from './FormError';

interface IProps {
  inputProps?: React.ComponentProps<typeof Input>;
  helper?: {
    text: string;
    icon?: boolean;
  };
  errors?: FieldErrors<FieldValues>;
  label?: string;
  className?: string;
}

const FormInput = ({
  inputProps,
  helper,
  errors,
  label,
  className,
}: IProps) => {
  const hasError = inputProps?.name && errors?.[inputProps?.name];

  return (
    <div className={twMerge('flex flex-col gap-2', className)}>
      <Input
        labelChildren={
          label ? (
            <p
              className={clsx({
                "after:content-['*'] after:text-primary-500":
                  inputProps?.required || inputProps?.isRequired,
              })}
            >
              {label}
            </p>
          ) : undefined
        }
        {...inputProps}
        className={twMerge(
          'outline-none !text-base h-full !rounded-[10px]',
          inputProps?.className
        )}
        containerClassName={twMerge(
          inputProps?.containerClassName,
          clsx({
            'border !border-mobile-gray-300 !rounded-[10px] w-full focus-within:!border-mobile-gray-500 h-12':
              true,
            '!border-primary-600': hasError,
          })
        )}
      />
      {hasError ? (
        // @ts-ignore
        <FormError error={errors?.[inputProps?.name]?.message} />
      ) : null}
      {helper ? (
        <div className="flex items-center gap-1">
          {helper?.icon ? <InfoFilled style={{ flex: '0 0 auto' }} /> : null}
          <p className="text-sm leading-[160%] text-mobile-gray-400">
            {helper?.text}
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default FormInput;
